// @flow

import { hpfetch } from '../util';
import type { wrappedApiResponseType } from '../apiTypes';
import type { geoipType } from '../../types';

export const getLocationFromIp = () =>
  hpfetch('geoip/').then(geoip => ({
    lat: geoip.body.latitude,
    lng: geoip.body.longitude,
  }));

export const getLocationFromIpFull = (): Promise<
  wrappedApiResponseType<geoipType>,
> => hpfetch('geoip/');

export const getLocationFromNavigator = () =>
  // Note: This produces a visible request.  Don't just use this
  // Make sure the user clicks a button to trigger it unless
  // Absolutely necessary
  new Promise<{ lat: number, lng: number }>((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        () => {
          // Didn't allow it
          reject(new Error('User rejected navigator location'));
        },
      );
    } else {
      // Browser doesn't support Geolocation
      reject(new Error('Browser does not support navigator location'));
    }
  });

export const getLocation = () =>
  getLocationFromIp()
    .catch(() => getLocationFromNavigator())
    .catch(() => null);
